import React from 'react';

const News = () => (
  <section id="news" className="g-pt-75 g-pb-45 g-bg-gray-light-v3">
    <div className="container">
      <header className="text-center g-width-60x--md mx-auto g-mb-20">
        <div className="u-heading-v2-3--bottom g-brd-primary g-mb-10">
          <h2 className="h4 u-heading-v2__title g-color-gray-dark-v2 g-font-weight-600 text-uppercase g-mt-minus-10 g-mb-5">
            Our Latest News
          </h2>
        </div>
        <p className="g-font-size-16 g-mb-0">Bishop K.J. Brown Ministry Events</p>
      </header>

      <div className="row">
        {/* Previous Events */}
        <div className="col-lg-4 g-mb-30">
          <article className="u-shadow-v21 g-bg-white rounded g-pa-30">
            <h3 className="g-font-weight-300 g-mb-15">
              <span>Previous Events</span>
            </h3>
            <p>
              Celebrated over 20 years of faithful ministry and service to the Body
              of Christ.
            </p>
            <div className="media g-font-size-12 g-brd-top g-brd-gray-light-v4 g-pa-15-30">
              <div className="media-body align-self-center">
                <span>&nbsp;</span>
              </div>
            </div>
          </article>
        </div>

        {/* Recent / Current Events */}
        <div className="col-lg-4 g-mb-30">
          <article className="u-shadow-v21 g-bg-white rounded g-pa-30">
            <h3 className="g-font-weight-300 g-mb-15">
              <span>Recent Events</span>
            </h3>
            <p>July 4, 2025 – Official launch of the new Bishop K.J. Brown Ministries website.</p>
          </article>
        </div>

        {/* Future Events */}
        <div className="col-lg-4 g-mb-30">
          <article className="u-shadow-v21 g-bg-white rounded g-pa-30">
            <h3 className="g-font-weight-300 g-mb-15">
              <span>Future Events</span>
            </h3>
            <p>
              Upcoming services, conferences, and special events will be posted here.
              Check back soon and stay connected with Bishop K.J. Brown Ministries.
            </p>
          </article>
        </div>
      </div>
    </div>
  </section>
);

export default News;
